// src/hooks/usePermissions.js
// Kullanıcı izinlerini yönetmek için hook

import { useAuth } from '../context/AuthContext';
import { hasModuleAccess, getAccessibleModules, MODULES } from '../config/rolePermissions';

/**
 * Kullanıcı izinlerini kontrol etmek için hook
 * @returns {object} - İzin kontrolü fonksiyonları ve erişilebilir modüller
 */
export const usePermissions = () => {
    const { currentUser } = useAuth();

    const role = currentUser?.role || 'Servis Teknisyeni'; // Varsayılan rol

    /**
     * Belirli bir modüle erişim izni var mı?
     * @param {string} moduleKey - Modül anahtarı
     * @returns {boolean}
     */
    const canAccess = (moduleKey) => {
        return hasModuleAccess(role, moduleKey);
    };

    /**
     * Tüm erişilebilir modül anahtarları
     */
    const accessibleModules = getAccessibleModules(role);

    /**
     * Kullanıcı yönetici mi?
     */
    const isAdmin = role === 'Yönetici';

    /**
     * Silme yetkisi kontrolü - Yönetici ve Ofis Personeli silebilir
     * @returns {boolean}
     */
    const canDelete = () => ['Yönetici', 'Ofis Personeli'].includes(role);

    /**
     * Modül bilgilerini getir
     */
    const getModuleInfo = (moduleKey) => MODULES[moduleKey];

    return {
        role,
        canAccess,
        accessibleModules,
        isAdmin,
        canDelete,
        getModuleInfo,
        MODULES
    };
};

export default usePermissions;
